import React from "react";

interface BtnProps {
    on_click_handler: any;
    is_disable?: boolean;
    other_classes?: string;
    type?: "primary" | "secondary";
    btn_label: string
    icon?: string;
}

const Button: React.FC<BtnProps> = ({
    on_click_handler,
    is_disable,
    other_classes = "",
    type = "primary",
    btn_label,
    icon,
}) => {
    const baseClasses = "w-full h-9 disabled:text-opacity-60 rounded-3xl text-xs font-medium transition-colors";
    const typeClasses =
        type === "primary"
            ? "bg-primary text-white hover:bg-secondary"
            : "bg-gray-300 text-gray hover:bg-gray-400";

    return (
        <button
            onClick={on_click_handler}
            disabled={is_disable}
            className={`${baseClasses} ${typeClasses} ${other_classes} ${is_disable ? "opacity-50 cursor-not-allowed" : ""}`}
        >
            {icon && <img src={icon} alt="icon" />}
            {btn_label}
            
        </button>
    );
};

export default Button;
